/**
 * @module mapbs.component.feedback.feedback
 */
import ngeoLocation from 'ngeo/statemanager/Location.js';
import angular from 'angular';

const moduleFeedback = angular.module('mapbsFeedbackModule', [ngeoLocation.name]);

moduleFeedback.run(
    /* @ngInject */ ($templateCache) => {
        $templateCache.put('mapbs/feedback', require('./feedback.html'));
    }
);

/**
 * @type {!angular.Component}
 */
const feedbackComponent = {
    controller: 'mapbsFeedbackController as feedbackCtrl',
    bindings: {
        feedbackShown: '=mapbsFeedbackShown',
    },
    templateUrl: () => 'mapbs/feedback',
};

moduleFeedback.component('mapbsFeedback', feedbackComponent);

class FeedbackController {
    /**
   * @param {!angular.Scope} $scope Angular scope.
   * @param {!angular.$http} $http Angular http service.
   * @param {string} mapbsFeedbackUrl URL of the mapbs feedbackservice webservice.
   * @param {ngeo.statemanager.Location} ngeoLocation ngeo Location service.
   * @constructor
   * @private
   * @ngInject
   */
    constructor($scope, $http, mapbsFeedbackUrl, ngeoLocation) {
    /**
     * @type {boolean}
     * @private
     */
        this.feedbackShown;

        /**
     * @type {boolean}
     * @private
     */
        this.feedbackSending = false;

        /**
     * @type {boolean}
     * @private
     */
        this.feedbackSent = false;

        /**
     * @type {boolean}
     * @private
     */
        this.feedbackError = false;

        /**
     * @type {angular.$http}
     * @private
     */
        this.http_ = $http;

        /**
     * @type {string}
     * @private
     */
        this.url_ = mapbsFeedbackUrl;

        /**
     * @type {!ngeo.statemanager.Location}
     * @private
     */
        this.ngeoLocation_ = ngeoLocation;

        /**
     * @type {string}
     * @private
     */
        this.permalink;

        /**
     * @type {string}
     * @export
     */
        this.email;

        /**
     * @type {string}
     * @export
     */
        this.emailOptional;

        /**
     * @type {string}
     * @export
     */
        this.feedbackText;

        $scope.$watch(
            () => {
                return this.feedbackShown;
            },
            (newValue) => {
                if (newValue) {
                    this.permalink = this.ngeoLocation_.getUriString();
                } else {
                    this.feedbackSending = false;
                    this.feedbackSent = false;
                    this.feedbackError = false;
                }
            }
        );
    }

    feedbackSubmit() {
        if (this.email && this.email.indexOf('@') === -1) {
            alert('Ungültige E-Mail Adresse');
            return;
        }

        if (this.emailOptional && this.emailOptional.indexOf('@bs.ch') === -1) {
            alert('Ungültige E-Mail Adresse');
            return;
        }

        if (!this.feedbackText) {
            alert('Bitte geben Sie eine Beschreibung des Problems ein.');
            return;
        }

        this.feedbackSending = true;

        this.http_
      .post(
          this.url_,
          $.param({
              permalink: this.permalink.toString(),
              ua: navigator.userAgent,
              email: this.email,
              email_optional: this.emailOptional, // eslint-disable-line camelcase
              feedback: this.feedbackText,
          }),
          {
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
              },
          }
      )
      .then(
          () => {
              this.feedbackSending = false;
              this.feedbackSent = true;
          },
          () => {
              this.feedbackSending = false;
              this.feedbackError = true;
          }
      );
    }
}

moduleFeedback.controller('mapbsFeedbackController', FeedbackController);

export default moduleFeedback;
